import React from "react";

function CustomStrategy() {
  return (
    <main className="custom_strategy">
      {/* Strategy Details Section */}
      <section className="strategy_detail_section">
        <div className="container">
          <div className="strategy_header">
            <div>
              <h2>Nifty–ATM ±2 Straddle (551575)</h2>
              <div className="tags">
                <span className="tag inhouse">In-House</span>
                <span className="tag intraday">Intraday</span>
                <span className="tag medium">Medium</span>
              </div>
            </div>
            <button className="btn_style_deploy">
              Deploy<i class="fa-solid fa-arrow-up-right-from-square"></i>
            </button>
          </div>

          <p className="strategy_desc">
            This is a directional, positional options strategy on the Nifty 50
            index, designed to capture short-term momentum during the weekly
            expiry cycle. The strategy can be deployed on the 1st, 2nd, or 3rd
            trading day of the expiry week, though 1st or 2nd day deployment is
            recommended. Early entry allows more time for recovery through
            banking-based adjustments if the position initially moves against
            the direction.
          </p>
          <p className="strategy_desc">
            The system dynamically identifies and aligns with the prevailing
            market direction. It maintains option-writing positions with close
            hedges, providing controlled exposure while retaining flexibility to
            adjust as market sentiment evolves. Positions are typically held
            until expiry, with no predefined stop loss or target, as risk and
            profit management are handled through adaptive hedging and
            adjustment logic.
          </p>

          <div class="table_content mt-4">
            <ul class="feature_list text-left">
              <li class="Coverage-list-2">
                <i class="fa-solid fa-check"></i>
                <span>Instrument</span> - Nifty–ATM ±2 Straddle (551575)
              </li>
              <li class="Coverage-list-2">
                <i class="fa-solid fa-check"></i>
                <span>Strategy Type </span> - Directional / Positional
              </li>
              <li class="Coverage-list-2">
                <i class="fa-solid fa-check"></i>
                <span>Entry </span> - 10:00 AM
              </li>
              <li class="Coverage-list-2">
                <i class="fa-solid fa-check"></i>
                <span>Exit </span> - 8:30 PM
              </li>
              <li class="Coverage-list-2">
                <i class="fa-solid fa-check"></i>
                <span>Days</span> - Mon , Tue , Wed
              </li>
              <li class="Coverage-list-2">
                <i class="fa-solid fa-check"></i>
                <span>Execution Type </span>- Live Trading
              </li>
              <li class="Coverage-list-2">
                <i class="fa-solid fa-check"></i>
                <span>Lot Size</span> - 100
              </li>
            </ul>
          </div>
          {/* Financial Metrics */}
          {/* <div className="strategy_metrics">
            <div className="metric">
              <span className="metric_label">Minimum Amount</span>
              <h6>₹17.50L</h6>
            </div>
            <div className="metric">
              <span className="metric_label">Capital Deployed</span>
              <h6>₹17.50L</h6>
            </div>
          </div> */}
        </div>
      </section>
    </main>
  );
}

export default CustomStrategy;
